import { BooleanType, ClassType, DateType, FloatType, IntegerType, IPropertyTypeVisitor, KnownClassType, ListType, PropertyType, ServerSideDataLoaderType, StringType, VoidType } from "../../structure";
import { DataModelBuilderViewModel, DataModelClass, Method, Property } from "../dataModelBuilder-viewModel";

export class DataModelJsonSerializer{
    serialize(dataModel : DataModelBuilderViewModel){
        let result = {
            type:"DataModel",
            classes : dataModel.classes.map(x=>this.serializeClass(x))
        }
        console.log(result);
        return result;
    }
    serializeClass(cls: DataModelClass): any {
        return {
            type:"class",
            name:cls.name,
            properties : cls.properties.map(x=>this.serializeProperty(x)),
            methods : cls.methods.map(x=>this.serializeMethod(x))
        }
    }
    serializeProperty(x: Property): any {
        return new propertySerializer().serialize(x);
    }
    serializeMethod(x: Method): any {
        return new methodSerializer().serialize(x);
    }

}

class propertySerializer implements IPropertyTypeVisitor{
    serialize(x: Property): any {
        return x.type.Accept(this,x);
    }

    convertBase(p:Property){
        let result = new genericTypeNameSerializer().GetTypeInfo(p.type);
        result.name=p.name;
        result.initialize = p.shallInitialize;
        result.preBody = p.preBody;
        result.postBody = p.postBody;
        return result;
    }

    visitVoidType(arg0: VoidType, p:Property) {
        throw new Error("Method not implemented.");
    }
    visitBooleanType(arg0: BooleanType, p:Property) {
        let result = <any>this.convertBase(p);
        result.default = p.defaultValue;
        return result;
    }
    visitIntegerType(arg0: IntegerType, p:Property) {
        let result = <any>this.convertBase(p);
        result.default = p.defaultValue;
        return result;
    }
    visitFloatType(arg0: FloatType, p:Property) {
        let result = <any>this.convertBase(p);
        result.default = p.defaultValue;
        return result;
    }
    visitStringType(arg0: StringType, p:Property) {
        let result = <any>this.convertBase(p);
        result.default = p.defaultValue;
        return result;
    }

    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, p:Property) {
        let result = <any>this.convertBase(p);
        result.default = p.defaultValue;
        return result;    
    }

    visitListType(arg0: ListType, p:Property) {
        let result = <any>this.convertBase(p);
        return result;

    }
    visitClassType(arg0: ClassType, p:Property) {
        throw new Error("Method not implemented.");
    }
    visitKnownClassType(arg0: KnownClassType, p:Property) {
        let result = <any>this.convertBase(p);
        return result;
    }
    visitDateType(arg0: DateType, p:Property) {
        let result = <any>this.convertBase(p);
        result.default = p.defaultValue;
        return result;    
    }
    
}

class genericTypeNameSerializer implements IPropertyTypeVisitor{
    public GetTypeInfo(propertyType:PropertyType){
        return propertyType.Accept(this,null);
    }

    visitVoidType(arg0: VoidType, parameter: any) {
        return {
            type:'void'
        }
    }
    visitBooleanType(arg0: BooleanType, parameter: any) {
        return {
            type:'boolean'
        }
    }
    visitIntegerType(arg0: IntegerType, parameter: any) {
        return {
            type:'integer'
        };
    }
    visitFloatType(arg0: FloatType, parameter: any) {
        return {
            type:'float'
        };
    }
    visitStringType(arg0: StringType, parameter: any) {
        return {
            type:'string'
        };
    }
    visitListType(arg0: ListType, parameter: any) {
        return {
            type:'list',
            ofType : this.GetTypeInfo(arg0.OfType)
        };
    }
    visitClassType(arg0: ClassType, parameter: any) {
        throw new Error("Method not implemented.");
    }
    visitKnownClassType(arg0: KnownClassType, parameter: any) {
        return {
            type:'knownClass',
            forClass : arg0.ForClass.name
        };
    } 

    visitServerSideDataLoaderType(arg0: ServerSideDataLoaderType, parameter: any) {
        return {
            type:'serverSideDataLoader'
        };
    }
    visitDateType(arg0: DateType, parameter: any) {
        return {
            type:'dateTime'
        }
    }
    
}

class methodSerializer{
    serialize(m: Method): any {
        return {
            name:m.name,
            isAsync : m.isAsync,
            arguments : m.arguments.map(x=>{
                return {
                    name:x.name,
                    type:new genericTypeNameSerializer().GetTypeInfo(x.type)
                }
            }),
            returnType : new genericTypeNameSerializer().GetTypeInfo(m.returnType),
            body : m.body
        }
    }
}

